import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

const OSANO_SRC =
	"https://cmp.osano.com/wapV4usL16/84654912-e60b-42f3-8797-2b008a863ede/osano.js";

export default function OsanoScript() {
	const [isInteractive, setIsInteractive] = useState(false);

	useEffect(() => {
		setIsInteractive(true);
	}, []);

	if (!isInteractive) {
		return null;
	}

	return (
		<Helmet>
			<script src={OSANO_SRC} />
		</Helmet>
	);
}
